import logger from 'debug';

const debug = logger('services:localStorageService');
const localStorageService = {
	saveToLocalStorage: (key, value) => {
		debug('saveToLocalStorage');

		if (typeof window !== 'undefined' && key !== 'undefined') {
			debug('window exists, window.localStorage:', window.localStorage);
			localStorage.setItem(key, value);
		}
		else {
			debug('window fails to exist.');
		}
	},
	getFromLocalStorage: (key) => {
		if (typeof window !== 'undefined' && key !== 'undefined') {
			debug('window exists, window.localStorage:', window.localStorage);
			return localStorage.getItem(key);
		}
		else {
			debug('window fails to exist.');
			return null;
		}
	}
}

const instance = Object.freeze(localStorageService);

export { instance as LocalStorageService };